export const EDIT_TYPE = '1'
export const ADD_NEW_TYPE = '2'
